module.exports = __webpack_public_path__ + "img/ipasmnt.862dc22d.svg";